import { render } from "./App.vue?vue&type=template&id=069623d4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=069623d4&lang=scss"

import exportComponent from "F:\\vue\\raven\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__